export default __webpack_public_path__ + "2ee0f6c7b49506426ed0a4b1b6cf4d16.png";